import { t } from "i18next";

export function Required(text: string) {
    return text + t('validation_required');    
}

export function RemoveMessage(text: string) {
    return text + t('will_be_deleted_are_you_sure');    
}